import { Tag } from "../../types/Tag";

import React, { useState } from "react";
import { Box, Chip, TextField, Autocomplete } from "@mui/material";

interface TagInputProps {
    tags: Tag[];
    onTagsChange: (tags: Tag[]) => void;
    tagError: string;
    setTagError: (tagError: string) => void;
    allTags?: Tag[];
}

const TagInput: React.FC<TagInputProps> = ({ tags, onTagsChange, tagError, setTagError, allTags }) => {
    const options: Tag[] = allTags?.filter((tag) => !tags.find((t) => t.id === tag.id)) || [];
    const [key, setKey] = useState<string>(String(Date.now()));

    function handleDeleteTag(tagToDelete: Tag) {
        onTagsChange(tags.filter((tag) => tag.id !== tagToDelete.id));
        setTagError("");
    }

    function handleAddTag(event: React.SyntheticEvent, value: Tag | null, reason: string) {
        if (reason === "selectOption" && value) {
            onTagsChange([...tags, value]);
            setTagError("");
            // Reset the key to force the Autocomplete component to re-render
            setKey(String(Date.now()));
        }
    }

    function handleEnterKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    }

    return (
        <Box>
            <Autocomplete
                disablePortal
                id="tags-input"
                key={key}
                options={options}
                getOptionLabel={(option) => option.label}
                onChange={handleAddTag}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Tags"
                        placeholder="Add tags"
                        onKeyDown={handleEnterKeyPress}
                        error={!!tagError}
                        helperText={tagError}
                        fullWidth
                        margin="normal"
                        sx={{
                            ".MuiInputBase-input": { fontSize: "large" },
                        }}
                    />
                )}
            />
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, m: 1 }}>
                {tags.map((tag) => (
                    <Chip key={tag.id} label={tag.label} onDelete={() => handleDeleteTag(tag)} color="primary" />
                ))}
            </Box>
        </Box>
    );
};

export default TagInput;
